<!--
 * @Description: 赛道详情
 * @Author:  单珊珊
 * @Date: 2022-02-21 09:50:44
 * @LastEditTime: 2023-02-20 15:56:52
 * @LastEditors:  
-->
<template>
  <div class="main-container noselect">
    <Spin fix v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    
    <div class="track-tag">
      <div class="header">
        <div class="left">
          <div class="title-underline">{{parent_track.type == 1 ? '细分赛道' : '相关推荐赛道'}}：</div>
          <div class="title">{{parent_tag.name}}</div>
        </div>
      </div>
      <div class="tags">
        <span class="tag" v-for="item,index in track_list" :key="index" :class="{'on': active_id == item.id}" @click="handleClickTag(item)">{{item.name}}</span>
      </div>
    </div>
    <div class="detail-container">
      <Spin fix v-if="loading2">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
      <div class="spe-banner">
        <div class="img-show">
          <img v-if="showThemeInfo" :src="detail.logo_path | logo_show" />
          <img v-else :src="$store.state.static_img_url + 'pic/vcbeat/default-theme.png'" />
        </div>
        <div class="s-bnr-info">
          <div class="cnt" v-if="showThemeInfo">
            <p class="p1">{{detail.title}}</p>
            <p class="p2">{{detail.summary}}</p>
          </div>
          <div class="cnt" v-else>
            <p class="p1">{{parent_tag.name + '—' + display_name}}</p>
            <p class="p2">{{parent_tag.name}}领域相关内容<br/>将于4月30日上线动脉橙产业智库，敬请期待！</p>
            <p class="p3">即将上线</p>
          </div>
        </div>
        <div class="promote">
          <img src="~pic/vbdata.png" />
          <div class="words">更多维度数据和赛道信息更新，申请试用可查看。</div>
          <button @click="haddleApplyTry2(18)">申请试用机构版</button>
        </div>
      </div>
      <div class="spe_content" :key="active_id">
        <div class="spe_content_l">
          <div class="lasted-updated" v-show="showThemeInfo && new_topic.length > 0">
            <div class="updated-item-wider">
              <div class="header">
                <div class="left title-underline topic-title">最新快讯</div>
              </div>
              <div class="list-wrap" style="margin-top: 22px;">
                <div class="item-list-wider" v-for="(item, index) in new_topic" :key="index">
                  <div class="type orange-back">快讯</div>
                  <div class="list-title over-p1" @click="goToNewDetail(item)">{{ item.title }}</div>
                  <div class="time">{{ item.create_time | time_standard}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="theme_content" v-if="theme_list.length">
            <div class="theme_li" v-for="item,index in theme_list" :key="item.module_id" :ref="'theme_li' + item.module_id" v-if="item.pid == null">
              <div class="theme_li_t">
                <span>{{item.name}}</span>
                <div class="apply-btn" v-if="index == 1" @click="haddleApplyTry2(16)">申请试用机构版</div>
              </div>
              <template v-if="item.is_show == 1">
                <ul class="theme_li_c">
                  <li class="describe" v-if="module_text[item.module_id].length > 0">
                    <ModuleDescribe :describeItem="item2" :moduleId="item.module_id" v-for="item2,index2 in module_text[item.module_id]" :key="index2"></ModuleDescribe>
                  </li>

                  <li v-for="item4,index4 in module_time_line[item.module_id]" :key="'time_line' + index4" class="module-li">
                    <TimeLine :paramsUid="params_uid" :moduleId="item.module_id" :timeLineItem="item4"></TimeLine>
                  </li>

                  <li v-for="item5,index5 in module_map[item.module_id]" :key="'map_line' + index5" class="module-li" v-if="item5.map_status == 1 || (item5.map_status == 0 && routerName == 'PreviewSpecialDetail')">
                    <LogoMap :paramsUid="params_uid" :mapItem="item5"></LogoMap>
                  </li>
                  <!-- 对比 -->
                  <li v-for="item7,index7 in module_tct[item.module_id]" :key="'module_tct' + index7" class="module-li tct" v-if="item7.status == 1 || (item7.status == 0 && routerName == 'PreviewSpecialDetail')">
                    <OrgContrast :cItem="item7" :paramsUid="params_uid" :meta="meta" v-if="item7.mode_type == 0"></OrgContrast>
                    <PointTime :cItem="item7" :paramsUid="params_uid" :meta="meta" v-if="item7.mode_type == 1"></PointTime>
                    <PointTag :cItem="item7" :paramsUid="params_uid" :meta="meta" v-if="item7.mode_type == 2"></PointTag>
                    <CompanySankey :cItem="item7" :paramsUid="params_uid" :meta="meta" v-if="item7.mode_type == 3"></CompanySankey>
                  </li>

                  <li v-for="item6,index6 in module_table[item.module_id]" :key="'map_line' + index6" class="module-li" v-if="item6.table_status == 1 || (item6.table_status == 0 && routerName == 'PreviewSpecialDetail')">
                    <TableList :paramsUid="params_uid" :moduleId="item.module_id" :tableItem="item6"></TableList>
                  </li>
                  <li v-for="item6,index6 in module_ppl[item.module_id]" :key="'map_ppl' + index6" class="module-li" v-if="item6.status == 1 || (item6.status == 0 && routerName == 'PreviewSpecialDetail')">
                    <PipelineCursor :paramsUid="params_uid" :moduleId="item.module_id" :pplItem="item6" :pplType="pplType" :pplNodeForm="pplNodeForm"></PipelineCursor>
                  </li>
                  <li v-for="item3,index3 in module_list[item.module_id]" :key="'module_list' + index3" class="module-li">
                    <ModuleLi :moduleItem="item3" :meta="meta" :moduleId="item.module_id" :moduleInsight="insight_content[item.module_id]"></ModuleLi>
                  </li>
                </ul>
                <div class="list_bottom" v-if="len[item.module_id] == 3">
                  <button class="more_btn" @click="haddleMore(item.module_id)">加载更多</button>
                </div>
              </template>
              <div class="theme-sec" v-for="secItem,secIndex in theme_module" :key="secIndex" :ref="'theme_li' + secItem.module_id" v-if="secItem.pid == item.module_id">
                <div class="theme-sec-title">
                  <span>{{secItem.name}}</span>
                  <img :src="$store.state.static_img_url + 'pic/lock-close.png'" v-if="item.is_show == 0" />
                </div>
                <template v-if="secItem.is_show == 1">
                  <ul>
                    <li class="describe" v-if="module_text[secItem.module_id].length > 0">
                      <ModuleDescribe :describeItem="secItem2" :moduleId="secItem.module_id" v-for="secItem2,secIndex2 in module_text[secItem.module_id]" :key="secIndex2"></ModuleDescribe>
                    </li>

                    <li v-for="secItem4,secIndex4 in module_time_line[secItem.module_id]" :key="'time_line' + secIndex4" class="module-li">
                      <TimeLine :paramsUid="params_uid" :timeLineItem="secItem4" :moduleId="secItem.module_id"></TimeLine>
                    </li>

                    <li v-for="secItem5,secIndex5 in module_map[secItem.module_id]" :key="'map_line' + secIndex5" class="module-li" v-if="secItem5.map_status == 1 || (secItem5.map_status == 0 && routerName == 'PreviewSpecialDetail')">
                      <LogoMap :paramsUid="params_uid" :mapItem="secItem5"></LogoMap>
                    </li>

                    <!-- 对比 -->
                    <li v-for="secItem7,secIndex7 in module_tct[secItem.module_id]" :key="'module_tct_' + secIndex7" class="module-li tct" v-if="secItem7.status == 1 || (secItem7.status == 0 && routerName == 'PreviewSpecialDetail')">
                      <OrgContrast :cItem="secItem7" :paramsUid="params_uid" :meta="meta" v-if="secItem7.mode_type == 0"></OrgContrast>
                      <PointTime :cItem="secItem7" :paramsUid="params_uid" :meta="meta" v-if="secItem7.mode_type == 1"></PointTime>
                      <PointTag :cItem="secItem7" :paramsUid="params_uid" :meta="meta" v-if="secItem7.mode_type == 2"></PointTag>
                      <CompanySankey :cItem="secItem7" :paramsUid="params_uid" :meta="meta" v-if="secItem7.mode_type == 3"></CompanySankey>
                    </li>

                    <li v-for="secItem6,secIndex6 in module_table[secItem.module_id]" :key="'table_line' + secIndex6" class="module-li" v-if="secItem6.table_status == 1 || (secItem6.table_status == 0 && routerName == 'PreviewSpecialDetail')">
                      <TableList :paramsUid="params_uid" :tableItem="secItem6"></TableList>
                    </li>
                    <li v-for="item6,index6 in module_ppl[secItem.module_id]" :key="'map_ppl' + index6" class="module-li" v-if="item6.status == 1 || (item6.status == 0 && routerName == 'PreviewSpecialDetail')">
                      <PipelineCursor :paramsUid="params_uid" :moduleId="item.module_id" :pplItem="item6" :pplType="pplType" :pplNodeForm="pplNodeForm"></PipelineCursor>
                    </li>
                    <li v-for="secItem3,secIndex3 in module_list[secItem.module_id]" :key="'module_list' + secIndex3" class="module-li">
                      <ModuleLi :moduleItem="secItem3" :meta="meta" :moduleId="secItem.module_id" :moduleInsight="insight_content[secItem.module_id]"></ModuleLi>
                    </li>
                  </ul>
                  <div class="list_bottom">
                    <button class="more_btn" @click="haddleMore(secItem.module_id)" v-if="len[secItem.module_id] == 3">加载更多</button>
                  </div>
                </template>
              </div>

            </div>
          </div>
          <!-- 申请试用 -->
          <div class="apply-container" ref="apply-container">
            <div class="apply-left">
              <img :src="$store.state.static_img_url+'pic/logo.png'" alt="动脉橙">
              <button @click="haddleApplyTry2(17)">申请试用</button>
            </div>
            <div class="apply-right">
              <div class="line-1">以上数据来自<span class="orange" @click="haddleApplyTry2(19)">动脉橙产业智库</span>。</div>
              <div class="line-2">
                <p>我们以独创的在线数据库方式，为健康产业人士提供全方位和实时的市场资讯、行业数据和分析师见解。现已覆盖数字健康、医疗器械、生物医药等近500+细分赛道，涉及公司名单、招投标、投融资信息、头部企业动态等各类数据并持续更新。</p>
              </div>
              <div class="line-3">
                点击 <span class="blue" @click="haddleApplyTry2(20)">【申请试用】</span>了解动脉橙产业智库更多内容。
              </div>
            </div>
          </div>
        </div>
        <div class="spe_content_r" v-show="showThemeInfo">
          <!-- 右侧导航 -->
          <div class="model-slider" ref="modelSlider">
            <p>导航目录</p>
            <div class="model-slider-cnt">
              <ul v-if="theme_module && theme_module.length > 0">
                <li v-for="item,index in theme_module" :key="index" v-if="!item.pid">
                  <a @click="haddleModelSlider(item,index)" :class="{active: slideModuleId == item.module_id}">{{item.name}}</a>
                  <img :src="$store.state.static_img_url + 'pic/lock-close.png'" v-if="item.is_show == 0" />
                  <ul>
                    <li v-for="item2,index2 in theme_module" :key="index2" v-if="item2.pid == item.module_id">
                      <a @click="haddleModelSlider(item2,index)" :class="{active: slideModuleId == item2.module_id}">{{item2.name}}</a>
                      <img :src="$store.state.static_img_url + 'pic/lock-close.png'" v-if="item2.is_show == 0" />
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getMeta,
  themeInfo,
  themeModule,
  themeNewsTopic,
  themeModulContentAll,
} from '@/service.js'

import ModuleLi from "../Special/components/ModuleLi";
import ModuleDescribe from "../Special/components/ModuleDescribe";
import TimeLine from "../Special/components/TimeLine";
import LogoMap from "../Special/components/LogoMap";
import TableList from "../Special/components/TableList";
import OrgContrast from "../Special/components/OrgContrast";
import PointTime from "../Special/components/PointTime";
import PointTag from "../Special/components/PointTag";
import CompanySankey from "../Special/components/CompanySankey";
import PipelineCursor from "../Special/components/PipelineCursor";

import filter from "js/filter";
import { left_scroll } from "js/left_scroll";
export default {
  metaInfo() {
    return {
      title: this.meta_title
    }
  },
  inject: ['haddleApplyTry2'],
  mixins: [left_scroll],
  data() {
    return {
      meta: '',
      parent_tag: {},
      parent_track: {},
      track_list: [],
      active_id: '',
      active_theme_uid: '',
      module_list: {},
      detail: {},
      new_topic: [],

      theme_module: [],
      page: {},
      module_list: {},
      insight_content: {},
      module_map: {},
      module_table: {},
      module_text: {},
      module_time_line: {},
      module_tct: {},
      module_ppl: {},
      len: {},
      loading: true,
      loading2: false,
      pplType: [],
      pplNodeForm: [],
      slideModuleId: '',
      showThemeInfo: true,
      default_track_list: [
        {
          id: '1',
          name: 'mRNA疗法'
        },
        {
          id: '2',
          name: '抗体偶联药物'
        },
        {
          id: '3',
          name: '小核酸药'
        },
        {
          id: '4',
          name: '干细胞疗法'
        },
        {
          id: '5',
          name: '基因治疗'
        },
        {
          id: '6',
          name: '溶瘤病毒'
        },
        {
          id: '7',
          name: '免疫细胞疗法'
        },
        {
          id: '8',
          name: '单克隆抗体'
        },
        {
          id: '9',
          name: '双特异性抗体'
        },
        {
          id: '10',
          name: 'CRO'
        },
        {
          id: '11',
          name: 'CMO/CDMO'
        },
        {
          id: '12',
          name: 'CSO'
        },
        {
          id: '13',
          name: 'AI+药'
        },
        {
          id: '14',
          name: '药企与数字疗法'
        },
      ]
    }
  },
  components: {
    ModuleLi,
    ModuleDescribe,
    TimeLine,
    LogoMap,
    TableList,
    OrgContrast,
    PointTime,
    PointTag,
    CompanySankey,
    PipelineCursor
  },
  computed: {
    theme_list() {
      return this.theme_module.filter(a => a.pid == null).slice(0, 2)
    },
    display_name() {
      return filter.dealNeed(this.active_id, this.track_list)
    },
    meta_title() {
      let str = ''
      if(this.showThemeInfo && this.detail.title) {
        str = this.detail.title + '-动脉橙'
      } else if(!this.showThemeInfo && this.parent_tag.name) {
        str = this.parent_tag.name + '—' + this.display_name + '-动脉橙'
      }
      return str || '动脉橙-数字健康产业信息服务商'
    }
  },
  created() {
    this.getMeta()
  },
  mounted() {
    if (this.$route.name === "trackDetail") {
      document.oncontextmenu = new Function("event.returnValue=false");
      document.onselectstart = new Function("event.returnValue=false");
    }

    let modelSliderTop = this.$refs.modelSlider.offsetTop - 52;
    this.haddleScroll(modelSliderTop);

    this.$nextTick(() => {
      window.onscroll = () => {
        this.listenerScroll("model-slider");
        this.haddleScroll(modelSliderTop);
      };
      window.onresize = () => {
        this.listenerScroll("model-slider");
      };
    });
  },
  beforeDestroy() {
    window.onscroll = ''
    window.onresize = ''
  },
  methods: {
    /**
     * 点击赛道标签
     */
    handleClickTag(item) {
      this.loading2 = true
      this.active_id = item.id
      this.display_name = item.name
      // 清空变量
      this.theme_module = []
      this.page = {}
      this.module_list = {}
      this.insight_content = {}
      this.module_map = {}
      this.module_table = {}
      this.module_text = {}
      this.module_time_line = {}
      this.module_tct = {}
      this.module_ppl = {}
      this.len = {}
      this.pplType = []
      this.pplNodeForm = []
      this.slideModuleId = ''
      item.theme_uid ? this.getThemeInfo(item.theme_uid) : this.showThemeInfo = false, this.loading2 = false
      _czc.push(['_trackEvent', '赛道详细页(新)', '顶部可切换标签', '点击量'])
    },
    //获取赛道列表
    async getMeta() {
      let res = await getMeta({
        name: [
          'getentitytagtrack',
          'gettrack',
          'entity_ntag',
          'theme_type',
          'address',
          'entity_ntag',
          'round',
          'annotation_tag',
          'unit',
          'tct_business_nature'
        ]
      }, (error) => {
        this.$Message.error('元数据请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'meta', res.meta)
        let theme_uid = ''
        if (this.$route.query.tag) {
          let tag_id = this.$route.query.tag
          let index = this.meta.getentitytagtrack.findIndex(a => a.app_layer_tag_id == tag_id)
          if (index > -1) {
            let pid = this.meta.getentitytagtrack[index].vbdata_all_round_pid
            this.parent_track = this.meta.getentitytagtrack[index]
            this.parent_tag = this.meta.gettrack.find(a => a.id == pid) || {}
            this.track_list = this.meta.gettrack.filter(a => a.pid == pid)
            this.active_id = this.meta.getentitytagtrack[index].vbdata_all_round_id
            theme_uid = this.meta.getentitytagtrack[index].theme_uid
          }else {
            let temp_index = this.meta.entity_ntag.findIndex(a => a.id == tag_id)
            let temp_pid = this.meta.entity_ntag[temp_index].pid
            this.track_list = this.default_track_list
            if (!temp_pid) {
              this.parent_tag = this.meta.entity_ntag[temp_index]
            }else {
              this.parent_tag = this.meta.entity_ntag.find(a => a.id == temp_pid) || {}
              // let tag_index = this.track_list.findIndex(a => a.id == tag_id)
              // tag_index > -1 ? this.active_id = this.track_list[tag_index].id : this.active_id = this.track_list[0].id
            }
            this.active_id = this.track_list[0].id

          }
        }
        if (this.$route.query.track) {
          let track_id = this.$route.query.track
          let index = this.meta.gettrack.findIndex(a => a.id == track_id)
          this.active_id = track_id
          if (index > -1) {
            let pid = this.meta.gettrack[index].pid
            this.parent_tag = this.meta.gettrack.find(a => a.id == pid) || {}
            this.track_list = this.meta.gettrack.filter(a => a.pid == pid)
            theme_uid = this.meta.gettrack[index].theme_uid
          }
        }
        theme_uid ? this.getThemeInfo(theme_uid) : this.showThemeInfo = false, this.loading = false
      } else {
        this.$Message.error(res)
      }
    },
    async getThemeInfo(uid) {
      this.showThemeInfo = true
      this.module_list = {};
      let res = await themeInfo({
        user_key: this.$store.state.user_key,
        theme_uid: uid,
        is_preview: 1
      }, error => this.$Message.error("请求错误！"));
      if (res.status == "success") {
        this.$set(this.$data, "detail", res.info[0]);
        // this.$set(this.$data, "theme_types", res.info[0].type_arr);
        let first_id, index = 0
        res.module.forEach(a => {
          if (index == 0 && a.pid == null) {
            first_id = a.module_id
            this.theme_module.push({ ...a, ...{ is_show: 1 } })
            index++
          } else {
            this.theme_module.push({ ...a, ...{ is_show: a.pid == first_id ? 1 : 0 } })
          }
        })
        this.theme_module.map(a => {
          if (first_id == a.pid) a.is_show = 1
        })
        let show_list = this.theme_module.filter(a => a.is_show == 1)
        this.getSpecialNewsList(res.info[0].id);
        if (show_list.length > 0) {
          let m_list = []
          show_list.map(a => {
            this.module_list[a.module_id] = [];
            this.insight_content[a.module_id] = [];
            this.module_text[a.module_id] = [];
            this.module_time_line[a.module_id] = [];
            this.module_map[a.module_id] = [];
            this.module_tct[a.module_id] = [];
            this.module_table[a.module_id] = [];
            this.module_ppl[a.module_id] = [];

            this.page[a.module_id] = 1;
            this.len[a.module_id] = 0;

            m_list.push(a.module_id);
          });
          this.getThemeModulContentAll(this.detail.id, m_list);
          let index2 = res.module.findIndex(b => b.pid == null);
          this.slideModuleId = res.module[index2].module_id;
        }

      } else {
        this.$Message.error(res.message);
      }
    },
    /**
     * 专题模块内容第一页
     * theme_id int 专题id
     * module_id array 专题模块数组
     */
    async getThemeModulContentAll(t_id, m_id) {
      let res = await themeModulContentAll({
        theme_id: t_id,
        module_id: m_id,
        is_preview: 1
      }, error => this.$Message.error("请求错误！"))
      this.loading = false
      this.loading2 = false
      if (res.status == "success") {
        res.res.map(a => {
          a.content.map(b => this.module_list[a.module_id].push(b));
          a.module_insight_content.map(b =>
            this.module_text[a.module_id].push(b)
          );
          a.insight_theme_content.map(b =>
            this.insight_content[a.module_id].push(b)
          );
          a.module_time_line.map(b =>
            this.module_time_line[a.module_id].push(b)
          );
          a.module_map.map(b => this.module_map[a.module_id].push(b));
          a.module_table.map(b => this.module_table[a.module_id].push(b));
          a.module_tct.map(b => this.module_tct[a.module_id].push(b));
          a.module_ppl.map(b => this.module_ppl[a.module_id].push(b));
          this.len[a.module_id] = a.content.length;
        });
        this.pplType = res.value
        this.pplNodeForm = res.node_form

        this.$forceUpdate();
        this.$previewRefresh();
        this.$nextTick(() => this.listenerScroll("model-slider"));
      } else {
        this.$Message.error(res.message);
      }
    },
    haddleMore(data_id) {
      this.page[data_id]++;
      this.getThemeModule(data_id, 1);
    },
    /**
     * 加载模块数据
     * data_id 对应模块module_id
     * is_more 是否加载更多 0否 1是
     */
    async getThemeModule(data_id, is_more) {
      let module_params = {
        module_id: data_id,
        theme_id: this.detail.id,
        page: this.page[data_id]
      };
      let res = await themeModule(module_params, error =>
        this.$Message.error("请求错误！")
      );
      if (res.status == "success") {
        res.res.map(a => this.module_list[data_id].push(a));
        res.module_text_content.map(a => this.module_text[data_id].push(a));
        res.insight_theme_content.map(a =>
          this.insight_content[data_id].push(a)
        );
        res.module_time_line.map(a => this.module_time_line[data_id].push(a));
        res.module_map.map(a => this.module_map[data_id].push(a));
        res.module_tct.map(a => this.module_tct[data_id].push(a));
        res.module_table.map(a => this.module_table[data_id].push(a));
        res.module_ppl.map(a => this.module_ppl[data_id].push(a));

        this.len[data_id] = res.res.length;
        this.$nextTick(() => this.listenerScroll("model-slider"));
        this.$forceUpdate();
        this.$previewRefresh();
        if (this.len[data_id] == 0 && is_more == 1) {
          this.$Message.warning('数据已加载完，没有更多了');
        }
      } else {
        this.$Message.error(res.message);
      }
    },
    async getSpecialNewsList(uid) {
      let res = await themeNewsTopic({
        page: 1,
        theme_id: uid
      }, error =>
        this.$Message.error("请求错误！")
      );
      if (res.status == "success") {
        this.$set(this.$data, "new_topic", res.res.slice(0, 5));
      } else {
        this.$Message.error(res.message);
      }
    },
    /**
     * 监听滚动条改变
     * m=监听的值
     */
    haddleScroll(m) {
      if (this.$refs.modelSlider) {
        this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop; //滚动条的值
        if (this.scrollTop > m) {
          this.$refs.modelSlider.classList.add("on");
        } else {
          this.$refs.modelSlider.classList.remove("on");
        }
        this.haddleSlideModule();
      }
    },
    /**
     * 右侧导航点击事件
     * item 点击的对象
     */
    haddleModelSlider(item, index) {
      // _czc.push(['_trackEvent', '专题详情页', this.detail.title+'导航目录点击（'+item.name+'）'])
      let targetTop 
      if (item.is_show == 1) {
        targetTop = this.$refs["theme_li" + item.module_id][0].offsetTop - 80;
      } else if (item.is_show == 0) {
        targetTop = this.$refs["apply-container"].offsetTop - 80;
      }
      let _this = this;
      $("html, body").animate({ scrollTop: targetTop }, 200, function () {
        _this.slideModuleId = item.module_id;
      });
    },
    /**
     * 导航高亮
     */
    haddleSlideModule() {
      this.themeLiTopArr = [];
      this.theme_module.map(a => {
        // if (a.is_show == 1) {
        this.themeLiTopArr.push({
          module_id: a.module_id,
          offset_top: this.$refs["theme_li" + a.module_id][0].offsetTop - 80
        });
        // }
      });
      this.themeLiTopArr.sort((a, b) => a.offset_top - b.offset_top);
      // console.log(this.themeLiTopArr, this.scrollTop)
      for (let i = 0; i < this.themeLiTopArr.length; i++) {
        if (this.scrollTop >= this.themeLiTopArr[i].offset_top) {
          this.slideModuleId = this.themeLiTopArr[i].module_id;
        }
      }
      this.$forceUpdate();
    },
    //跳转至快讯
    goToNewDetail(item) {
      const href2 = this.$store.state.index2_path + '/newsDetail/' + item.uid
      window.open(href2, '_blank')
      _czc.push(['_trackEvent', '赛道详细页(新)', '最新快讯', '点击量'])
    },
    beforeDestroy() {
      document.oncontextmenu = new Function("event.returnValue=true");
      document.onselectstart = new Function("event.returnValue=true");
    },
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/track_detail.stylus'
@import '~styles/common_track.stylus'
.noselect
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select none
.detail-container
  position: relative
.p3
  width 86px
  height 24px
  line-height 24px
  background #FC3B3B
  border-radius 12px
  font-size 14px
  color #FFFFFF
  text-align center
  margin-top 68px
.apply-container
  margin-top 20px
  background #FFFFFF
  padding 20px
  width 100%
  display flex
  // justify-content space-between
  .apply-left
    flex 0 0 216px
    height 205px
    background #FFFBF7
    display flex
    flex-direction column
    justify-content center
    align-items center
    img
      width 113px
    button
      margin-top 20px
      width 100px
      height 36px
      border 1px solid #FA5A00
      font-size 14px
      color #FA5A00
      line-height 36px
      cursor pointer
      background none
      &:hover
        border 1px solid #FF4800
        color #FF4800
  .apply-right
    flex 0 0 462px
    border-top 1px solid #EEEEEE
    border-bottom 1px solid #EEEEEE
    margin-left 22px
    padding 16px 0
    display flex
    flex-direction column
    justify-content space-between
    color #666666
    line-height 20px
    .line-1
      font-weight 500
      font-size 13px
      .orange
        cursor pointer
        &:hover
          color #FF4800
    .line-2
      font-size 12px
    .line-3
      font-weight 500
      font-size 13px
      .blue
        color #6888F8
        cursor pointer
        &:hover
          color #98aefb
.main-container
  >>> .lasted-updated
    margin-bottom 20px
    .topic-title
      margin-top 20px
      margin-left 20px
    .updated-item-wider
      background #FFFFFF !important
    .list-wrap
      .item-list-wider
        display flex
        padding-bottom 20px
        .type
          margin-right 8px
          height 18px
          flex 0 0 36px
          padding 0
          display flex
          justify-content center
          align-items center
          font-size 12px
          color #fff
        .list-title
          flex 1
          margin 0
          height 18px
          line-height 18px !important
        .time
          flex 0 0 90px
          font-size 12px
          color #999999
          line-height 18px
          text-align right
</style>
